// src/Components/Contact.js
import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import emailjs from "emailjs-com";

class Contact extends Component {
  state = {
    contactName: "",
    contactEmail: "",
    contactSubject: "",
    contactMessage: "",
    loading: false,
    success: false,
    error: ""
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      success: false,
      error: ""
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { contactName, contactEmail, contactSubject, contactMessage } =
      this.state;

    if (!contactName || !contactEmail || !contactMessage) {
      this.setState({ error: "Please fill in all required fields." });
      return;
    }

    this.setState({ loading: true, error: "", success: false });

    console.log("Sending EmailJS request…");

    emailjs
      .send(
        "service_xlmtnmb", // ✅ service ID
        "template_t400d78", // ✅ template ID
        {
          // ✅ these MUST match the variables in your template
          name: contactName,
          email: contactEmail,
          subject: contactSubject || "Portfolio Contact",
          message: contactMessage
        },
        "UaOdMg3WjwabXagMQ" // ✅ public key
      )
      .then(
        (res) => {
          console.log("EmailJS SUCCESS:", res.status, res.text);
          this.setState({
            loading: false,
            success: true,
            contactName: "",
            contactEmail: "",
            contactSubject: "",
            contactMessage: ""
          });
        },
        (err) => {
          console.error("EmailJS ERROR:", err);
          this.setState({
            loading: false,
            error:
              "Email service failed: " +
              (err?.text || "Something went wrong. Please try again.")
          });
        }
      );
  };

  render() {
    if (!this.props.data) return null;

    const {
      name,
      address,
      phone,
      email,
      contactmessage: message
    } = this.props.data || {};
    const { city, state } = address || {};

    const {
      contactName,
      contactEmail,
      contactSubject,
      contactMessage,
      loading,
      success,
      error
    } = this.state;

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Get in touch.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">{message}</p>
            </div>
          </div>
        </Fade>

        <div className="row contact-row">
          <Slide left duration={1000}>
            <div className="eight columns">
              <div className="contact-card">
                <form id="contactForm" onSubmit={this.handleSubmit}>
                  <fieldset>
                    <div className="field">
                      <label htmlFor="contactName">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        value={contactName}
                        id="contactName"
                        name="contactName"
                        onChange={this.handleChange}
                      />
                    </div>

                    <div className="field">
                      <label htmlFor="contactEmail">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        type="email"
                        value={contactEmail}
                        id="contactEmail"
                        name="contactEmail"
                        onChange={this.handleChange}
                      />
                    </div>

                    <div className="field">
                      <label htmlFor="contactSubject">Subject</label>
                      <input
                        type="text"
                        value={contactSubject}
                        id="contactSubject"
                        name="contactSubject"
                        onChange={this.handleChange}
                      />
                    </div>

                    <div className="field">
                      <label htmlFor="contactMessage">
                        Message <span className="required">*</span>
                      </label>
                      <textarea
                        id="contactMessage"
                        name="contactMessage"
                        rows="6"
                        value={contactMessage}
                        onChange={this.handleChange}
                      />
                    </div>

                    <div className="contact-actions">
                      <button
                        className="submit contact-submit"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send message"}
                      </button>

                      {loading && (
                        <span id="image-loader">
                          <img alt="" src="images/loader.gif" />
                        </span>
                      )}
                    </div>

                    {error && (
                      <div
                        id="message-warning"
                        className="contact-message error"
                      >
                        {error}
                      </div>
                    )}

                    {success && (
                      <div
                        id="message-success"
                        className="contact-message success"
                      >
                        <i className="fa fa-check" /> Your message was sent,
                        thank you!
                      </div>
                    )}
                  </fieldset>
                </form>
              </div>
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact contact-card">
                <h4>Address &amp; Contact</h4>
                <p className="address">
                  {name}
                  <br />
                  {city && state && (
                    <>
                      {city}, {state}
                      <br />
                    </>
                  )}
                  {phone && (
                    <>
                      <span>{phone}</span>
                      <br />
                    </>
                  )}
                  {email && <span>{email}</span>}
                </p>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
